export function formatNumber(value: any) {
    return Number(value || 0).toLocaleString('ko-KR');
}

export function formatPrice(value: any) {
    const price = Number(value || 0);
    return price > 0 ? `${price.toLocaleString('ko-KR')}원` : '-';
}

export function formatVolume(value: any) {
    const number = Number(value || 0);
    if (number >= 100000000) return `${(number / 100000000).toFixed(1)}억`;
    if (number >= 10000) return `${(number / 10000).toFixed(1)}만`;
    return number.toLocaleString('ko-KR');
}

export function formatPercent(value: any) {
    const number = Number(value || 0);
    return `${number > 0 ? '+' : ''}${number.toFixed(2)}%`;
}

export function formatTime(value: any) {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '--:--';
    return new Intl.DateTimeFormat('ko-KR', {
        timeZone: 'Asia/Seoul',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    }).format(date);
}

export function formatBarTime(value: any) {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '--.-- --:--';
    const parts = new Intl.DateTimeFormat('ko-KR', {
        timeZone: 'Asia/Seoul',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    }).formatToParts(date);
    const part = (type: string) => (
        parts.find(item => item.type === type)?.value || '--'
    );
    return `${part('month')}.${part('day')} ${part('hour')}:${part('minute')}`;
}
